import MortgageDropDownList, { SelectOptions } from '@/components/Controls/MortgageDropDownList';
import './DropDownBlockWidget.scss';

import Vue from 'vue';
import { RootElementAttrsHolder } from '@/plugins/RootElementAttrsPlugin';
import { JSONParser } from '@/utils/JSONParser';

interface Group {
    mortgageProgramName: string;
    mortgageProgramDescription: string;
    mortgageProgramMonthlyPayment: string;
    mortgageProgramFlatOldPrice: string;
    mortgageProgramFlatPrice: string;
}

type GroupList = Group[];

export function createDropDownBlockWidget(el: Element) {
    const parser = new JSONParser('createDropDownBlockWidget');
    const rootAttrs = new RootElementAttrsHolder(el);

    const rawList = el.getAttribute('data-list');
    const rawModal = el.getAttribute('data-modal');
    const upadateName = el.getAttribute('data-update-name');

    return new Vue({
        el,
        name: 'DropDownBlockWidget',
        rootAttrs,
        data: {
            list: parser.parse<GroupList>(rawList),
            modal: rawModal,
            active: 0,
            upadateName: upadateName,
        },
        computed: {
            selectOptions(): SelectOptions {
                return this.list?.map((item, i) => ({
                    label: item.mortgageProgramName,
                    description: item.mortgageProgramDescription,
                    monthlypayment: item.mortgageProgramMonthlyPayment,
                    oldprice: item.mortgageProgramFlatOldPrice,
                    price: item.mortgageProgramFlatPrice,
                    value: i,
                }));
            },
        },
        render(h) {
            return (
                <div class="grouped-links-list">
                    <MortgageDropDownList
                        v-model={this.active}
                        modalcallback={this.modal}
                        upadateName={this.upadateName}
                        options={this.selectOptions}
                        class="grouped-list"
                    />
                </div>
            );
        },
    });
}
